import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class SelectOptions extends Component {
	constructor() {
		super();

		this.over = false;
		this.alreadyFocused = false;
		this.alreadyBlured = false;

		this.state = {
			hideList: true
		};

		this.hideList = () => {
			this.setState({
				hideList: true
			});
		};

		this.handleKeyDown = (e) => {
			if (e.keyCode === 9) {
				this.pressedTab = true;
			}
		};

		this.handleBlur = () => {
			if (!this.pressedTab) {
				if (this.over) {
					if (this.alreadyBlured) {
						this.alreadyBlured = false;
					} else {
						this.select.focus();
					}
				} else {
					this.hideList();
				}
			} else {
				this.pressedTab = false;
			}
		};

		this.handleClickClickable = (e) => {
			e.stopPropagation();

			if (this.alreadyFocused) {
				this.alreadyFocused = false;
			} else {
				this.alreadyBlured = true;
				this.hideList();
				this.select.blur();
			}
		};

		this.handleMouseOver = () => {
			this.over = true;
		};

		this.handleMouseOut = () => {
			this.over = false;
		};

		document.body.addEventListener('click', () => {
			if (!this.over) {
				this.hideList();
			}
		});

		this.handleFocus = () => {
			this.setState({
				hideList: false
			});

			this.alreadyFocused = true;
		};

		this.handleAnchorBlur = () => {
			this.hideList();
		};
	}

	render() {
		const { className, label } = this.props;
		const { hideList } = this.state;

		return (
			<div
				className={`select-options${className ? ` ${className}` : ''}${hideList
					? ''
					: ' select-options--show'}`}
				ref={(ref) => {
					this.select = ref;
				}}
				tabIndex="0"
				onMouseOver={this.handleMouseOver}
				onMouseOut={this.handleMouseOut}
				onKeyDown={this.handleKeyDown}
				onFocus={this.handleFocus}
				title="Zmień instytucję"
			>
				<div className="select-options__clickable" onClick={this.handleClickClickable}>
					<div className="select-options__name" aria-hidden="true">
						{label}
						<i className="fa fa-angle-down select-options__icon" aria-hidden="true" />
					</div>
					<div className="select-options__selected" aria-hidden="true">
						Wybrany
					</div>
				</div>
				<div className="select-options__shadow" />
				<ul className="select-options__list">
					{this.props.items.map((item) => (
						<li className="select-options__element">
							<a
                                className="select-options__link"
                                onBlur={this.handleAnchorBlur}
                                href="#"
                                title={`Zmień jednostkę na ${item.name}`}
							>
								<span aria-hidden="true">{item.name}</span>
							</a>
						</li>
					))}
				</ul>
			</div>
		);
	}
}

SelectOptions.propTypes = {
	className: PropTypes.string,
	label: PropTypes.string,
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string
		})
	)
};

SelectOptions.defaultProps = {
	items: []
};
